<template>
  <div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title"><b>Create a Knosis Username</b></p>
        <button class="delete" aria-label="close" @click="$emit('close')"></button>
      </header>
      <section class="modal-card-body">
        <div class="field is-horizontal">
          <div class="field-label">
            <label class="label">Username:</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control is-expanded has-icons-left">
                <input class="input"
                       type="text"
                       id="username"
                       placeholder="Username"
                       :value="username.toLowerCase()"
                       @input="username = $event.target.value.toLowerCase()"
                       @keyup="checkUsername"
                       required>
                <span class="icon is-small is-left">
                      <i class="fas fa-user"></i>
                    </span>
              </div>
            </div>
            <div class="field">
              <div class="control is-expanded">
                <b class="help is-success" v-if="usernameAvailable">
                  @{{username}} is available
                </b>

                <b class="help is-danger" v-if="!usernameAvailable">
                  @{{username}} has already been taken
                </b>
              </div>
            </div>
          </div>

        </div>
      </section>
      <footer class="modal-card-foot">
        <button class="button is-fullwidth" @click="submitUsername(); $emit('close')">Submit</button>
      </footer>
    </div>
  </div>
</template>

<script>
  import debounce from 'lodash/debounce';
  import * as firebase from 'firebase'

  export default {
    data() {
      return {
        usernameAvailable: true,
        username: ''
      }
    },
    methods: {
      checkUsername:debounce( function() {
          firebase.database().ref('users').once('value')
            .then((data) => {
              const obj = data.val()  // store all objects
              for (let key in obj) {
                if(obj[key].username == this.username){
                  this.usernameAvailable = false
                  return
                }
              }
              this.usernameAvailable = true
            })
        },
        // This is the number of milliseconds we wait for the
        // user to stop typing.
        500),
      submitUsername() {
        if (this.username !== '' &&
            this.usernameAvailable) {
            firebase.database().ref('users').child(firebase.auth().currentUser.uid).update({
              username: this.username
            })
            .catch((error) => { console.log(error) })
        } else {
          alert('Username cannot be empty')
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/usernameModal.vue